import Conditions from '../constants/conditions';
import RouterComponents from '../../permissions/constants/routerComponents';
import UserPermissions from '../constants/userPermissions';
import { PartialRecord, PermissionRules } from '../usePermissions';

type routerComponentRegistry = {
  [name in RouterComponents]: PermissionRules;
};

const RouterComponentRegistry: routerComponentRegistry = {
  UseMenuItems: {
    [UserPermissions.VIEW_ORGANIZATION_SETTINGS]: true,
    [UserPermissions.START_SUPPORT_SESSION]: true,
    [UserPermissions.VISUALIZE_LEGACY_JOBS]: true,
    [UserPermissions.CREATE_USER_WITH_ROLE]: true,
    [UserPermissions.VIEW_ANALYTICS]: true,
    [UserPermissions.VIEW_WORKSPACE_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      if (conditions.noWorkspaces) return false;
      return true;
    },
    [UserPermissions.VIEW_DRIVERS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      if (conditions.noWorkspaces) return false;
      return true;
    },
    [UserPermissions.VIEW_ROUTES]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.workspaceDeleted) return false;
      if (conditions.noWorkspaces) return false;
      return true;
    },
    [UserPermissions.VIEW_VISITS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.workspaceDeleted) return false;
      if (conditions.noWorkspaces) return false;
      return true;
    },
    [UserPermissions.UPDATE_USER_PASSWORD_AS_ADMIN]: true,
  },
  MainMenu: {
    [UserPermissions.START_SUPPORT_SESSION]: true,
    [UserPermissions.VISUALIZE_LEGACY_JOBS]: true,

  },
  NavigationMenu: {
    [UserPermissions.VIEW_WORKSPACE_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.VIEW_PROJECTS]: true,
    [UserPermissions.START_SUPPORT_SESSION]: true,
    [UserPermissions.VISUALIZE_LEGACY_JOBS]: true,
    [UserPermissions.UPDATE_USER_PASSWORD_AS_ADMIN]: true,
  },
  Workspace: {
    [UserPermissions.VIEW_ROUTES]: true,
    [UserPermissions.VIEW_VISITS]: true,
    [UserPermissions.VIEW_DRIVERS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      return true;
    },
  },
};

export default RouterComponentRegistry;
